<template>
  <div class="wallet-mobile-container">
    <!-- 顶部导航栏 -->
    <div class="header-bar">
      <div class="left" @click="$router.go(-1)">
        <i class="el-icon-arrow-left" />
        <span>我的钱包</span>
      </div>
    </div>

    <!-- 1. 钱包余额与快捷操作核心卡片 -->
    <div class="wallet-overview-card">
      <div class="balance-title">账户余额 (元)</div>
      <div class="balance-amount">
        <span class="currency">￥</span>
        <span class="num">{{ wallet.balance }}</span>
      </div>
      <div class="action-buttons-row">
        <div class="action-btn charge" @click="showChargeDialog">
          <i class="el-icon-plus" /> 充值
        </div>
        <div class="action-btn transfer" @click="showTransferDialog">
          <i class="el-icon-position" /> 转账
        </div>
      </div>
    </div>

    <!-- 2. 小会员状态卡片 -->
    <div class="vip-status-card">
      <div class="vip-card-left">
        <div class="vip-icon-box">
          <i class="el-icon-medal" />
        </div>
        <div class="vip-info">
          <h4>尊贵的小会员</h4>
          <p v-if="myVip === null">加载中...</p>
          <template v-else>
            <p v-if="!myVip.isVip">您当前还不是小会员</p>
            <p v-else-if="myVip.expired">您的小会员已过期</p>
            <p v-else>剩余 <span class="highlight">{{ myVip.expireIn }}</span> 天到期</p>
          </template>
        </div>
      </div>
      <div class="vip-card-right">
        <span v-if="myVip && !myVip.isVip" class="op-btn" @click="showPlanDialog">立即开通</span>
        <span v-else-if="myVip && myVip.expired" class="op-btn" @click="showPlanDialog">立即续费</span>
        <span v-else class="op-btn renew" @click="showPlanDialog">续费会员</span>
      </div>
    </div>

    <!-- 3. 账单明细列表 -->
    <div class="bill-section">
      <div class="section-title">
        <i class="el-icon-tickets" /> 账单明细
      </div>

      <div v-if="dataList.length > 0" class="bill-list">
        <div v-for="(item, index) in dataList" :key="index" class="bill-item">
          <div class="bill-left">
            <div class="bill-type-icon" :class="item.type === '支出' ? 'expense' : 'income'">
              <i :class="item.type === '支出' ? 'el-icon-top' : 'el-icon-bottom'" />
            </div>
            <div class="bill-info">
              <span class="bill-name">{{ item.type || '交易记录' }}</span>
              <span class="bill-time">{{ item.createAt }}</span>
            </div>
          </div>
          <div class="bill-right" :class="item.type === '支出' ? 'amount-expense' : 'amount-income'">
            {{ item.type === '支出' ? '-' : '+' }}￥{{ item.quantity }}
          </div>
        </div>

        <!-- 底部加载更多提示 -->
        <div class="load-more-bar" v-if="totalSize > dataList.length">
          <el-button type="text" :loading="loadingMore" @click="loadMoreBills">点击加载更多</el-button>
        </div>
      </div>

      <!-- 空状态 -->
      <div v-else class="empty-state">
        <i class="el-icon-document" />
        <p>暂无任何账单明细~</p>
      </div>
    </div>

    <!-- 充值弹窗 -->
    <el-dialog
      title="账户充值"
      append-to-body
      :visible.sync="chargeDialog"
      width="90%"
      center
      custom-class="mobile-dialog"
    >
      <el-form ref="form" :model="chargeForm" label-position="top">
        <el-form-item label="请输入充值金额 (元)">
          <el-input-number v-model="chargeForm.amount" :min="1" :max="100" class="full-width-input" size="medium" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="chargeDialog = false">取 消</el-button>
        <el-button type="primary" size="small" @click="onCharge">确认充值</el-button>
      </span>
    </el-dialog>

    <!-- 安全转账弹窗 -->
    <el-dialog
      title="安全转账"
      append-to-body
      :visible.sync="transferDialog"
      width="90%"
      center
      custom-class="mobile-dialog"
    >
      <el-form ref="form" :model="transferForm" label-position="top">
        <el-form-item label="选择收款联系人">
          <el-select v-model="transferForm.userId" placeholder="请选择联系人" class="full-width-input" size="medium">
            <el-option
              v-for="item in contactList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="转账金额 (元)">
          <el-input-number v-model="transferForm.amount" :min="1" :max="10000" class="full-width-input" size="medium" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="transferDialog = false">取 消</el-button>
        <el-button type="success" size="small" @click="transferTo">确认转账</el-button>
      </span>
    </el-dialog>

    <!-- 开通 / 续费会员弹窗 -->
    <el-dialog
      title="开通 / 续费小会员"
      append-to-body
      :visible.sync="planDialog"
      width="90%"
      center
      custom-class="mobile-dialog"
    >
      <el-form ref="form" :model="planForm">
        <el-form-item label="请选择订阅方案" label-position="top">
          <el-radio-group v-model="planForm.planId" class="modern-radio-group">
            <el-radio
              v-for="(item, index) in vipPlans"
              :key="index"
              :label="item.planId"
              border
              class="plan-radio-item"
            >
              <div class="plan-radio-content">
                <span class="plan-name">{{ item.name }}</span>
                <span class="plan-price">￥{{ item.price }}</span>
              </div>
            </el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="planDialog = false">取 消</el-button>
        <el-button type="primary" size="small" @click="buy">立即支付</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { addApprovalRequest, getWallet, getWalletBill } from '@/api/user'
import { buyVip, getMyVip, getVipPlans } from '@/api/account'

export default {
  name: 'MyWalletMobile',
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      totalSize: 0,
      dataList: [],
      loadingMore: false,
      chargeDialog: false,
      chargeForm: {
        amount: null
      },
      contactList: [],
      transferDialog: false,
      transferForm: {
        userId: 0,
        amount: null
      },
      wallet: {
        balance: '0.00'
      },
      planDialog: false,
      vipPlans: [],
      planForm: {
        planId: null,
        amount: null
      },
      myVip: null
    }
  },
  created() {
    document.title = '我的钱包'
    getWallet().then(resp => {
      if (resp && resp.code === 0) {
        this.wallet = resp.data
      }
    })

    getMyVip().then(resp => {
      if (resp && resp.code === 0) {
        this.myVip = resp.data
      }
    })

    this.getBillRecord()
  },
  methods: {
    showChargeDialog() {
      this.chargeDialog = true
    },
    onCharge() {
      if (this.chargeForm.amount === null) {
        this.$message('请填写充值金额')
        return
      }
      this.chargeDialog = false

      const requestData = {
        bizType: 'walletCharge',
        bizPayload: JSON.stringify({ amount: this.chargeForm.amount })
      }
      addApprovalRequest(requestData).then(resp => {
        if (resp && resp.code === 0) {
          this.$message.info('充值请求已提交')
        } else {
          this.$message.warning(resp.msg)
        }
      }).catch(error => {
        this.$message.error('充值失败: ' + error.message)
      })
    },
    showTransferDialog() {
      this.transferDialog = true
      this.$message.info('获取联系人')
    },
    transferTo() {
      this.$message.info('转帐功能开发中')
    },
    getBillRecord() {
      getWalletBill().then(resp => {
        if (resp && resp.code === 0) {
          this.dataList = resp.data || []
          this.totalSize = resp.data.length || 0
        }
      })
    },
    loadMoreBills() {
      this.loadingMore = true
      setTimeout(() => {
        this.loadingMore = false
      }, 500)
    },
    showPlanDialog() {
      this.planDialog = true
      getVipPlans().then(resp => {
        if (resp && resp.code === 0) {
          this.vipPlans = resp.data || []
        }
      })
    },
    buy() {
      this.planDialog = false
      buyVip(this.planForm).then(resp => {
        if (resp && resp.code === 0) {
          this.$notify.info({
            message: '小会员已开通',
            duration: 3000
          })
        } else {
          this.$notify.error({
            message: resp.msg,
            duration: 3000
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.wallet-mobile-container {
  min-height: 100vh;
  background-color: #f4f5f7;
  padding-top: 50px;
  padding-bottom: 20px;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}

/* 顶部导航栏 */
.header-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 50px;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  padding: 0 15px;
  z-index: 100;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);

  .left {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 16px;
    font-weight: 500;
    color: #303133;
    cursor: pointer;
    i { font-size: 18px; }
  }
}

/* 1. 钱包总览卡片 */
.wallet-overview-card {
  background: linear-gradient(135deg, #3498db 0%, #2980b9 100%);
  margin: 12px;
  padding: 20px;
  border-radius: 12px;
  color: #ffffff;
  box-shadow: 0 4px 12px rgba(52, 152, 219, 0.2);

  .balance-title {
    font-size: 13px;
    opacity: 0.85;
    margin-bottom: 4px;
  }

  .balance-amount {
    display: flex;
    align-items: baseline;
    margin-bottom: 20px;

    .currency {
      font-size: 18px;
      font-weight: bold;
    }

    .num {
      font-size: 32px;
      font-weight: bold;
      letter-spacing: -0.5px;
      margin-left: 2px;
    }
  }

  .action-buttons-row {
    display: flex;
    gap: 12px;

    .action-btn {
      flex: 1;
      text-align: center;
      padding: 8px 0;
      border-radius: 6px;
      font-size: 13px;
      font-weight: 500;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 4px;

      &.charge {
        background-color: #ffffff;
        color: #2980b9;
      }

      &.transfer {
        background-color: rgba(255, 255, 255, 0.2);
        color: #ffffff;
        border: 1px solid rgba(255, 255, 255, 0.4);
      }
    }
  }
}

/* 2. 小会员状态卡片 */
.vip-status-card {
  background-color: #ffffff;
  margin: 0 12px 12px 12px;
  padding: 14px 16px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.03);

  .vip-card-left {
    display: flex;
    align-items: center;
    gap: 12px;

    .vip-icon-box {
      width: 36px;
      height: 36px;
      background-color: #fce4ec;
      color: #fb7299;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      flex-shrink: 0;
    }

    .vip-info {
      h4 {
        font-size: 14px;
        color: #212121;
        margin: 0 0 2px 0;
        font-weight: bold;
      }
      p {
        font-size: 12px;
        color: #909399;
        margin: 0;

        .highlight {
          color: #fb7299;
          font-weight: bold;
        }
      }
    }
  }

  .vip-card-right {
    .op-btn {
      font-size: 12px;
      font-weight: 500;
      color: #ffffff;
      background-color: #fb7299;
      padding: 5px 12px;
      border-radius: 14px;
      cursor: pointer;

      &.renew {
        background-color: #f4f5f7;
        color: #fb7299;
        border: 1px solid #fad2e1;
      }
    }
  }
}

/* 3. 账单明细板块 */
.bill-section {
  background-color: #ffffff;
  margin: 0 12px;
  padding: 14px 16px;
  border-radius: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.03);

  .section-title {
    font-size: 14px;
    font-weight: bold;
    color: #212121;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    gap: 6px;

    i { color: #3498db; }
  }

  .bill-list {
    .bill-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px 0;
      border-bottom: 1px solid #f9f9f9;

      &:last-child {
        border-bottom: none;
      }

      .bill-left {
        display: flex;
        align-items: center;
        gap: 10px;

        .bill-type-icon {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;

          &.expense {
            background-color: #fdeede;
            color: #e6a23c;
          }

          &.income {
            background-color: #f0fdf4;
            color: #10b981;
          }
        }

        .bill-info {
          display: flex;
          flex-direction: column;

          .bill-name {
            font-size: 13px;
            color: #303133;
            font-weight: 500;
          }

          .bill-time {
            font-size: 11px;
            color: #909399;
            margin-top: 2px;
          }
        }
      }

      .bill-right {
        font-size: 14px;
        font-weight: bold;

        &.amount-expense {
          color: #f56c6c;
        }

        &.amount-income {
          color: #10b981;
        }
      }
    }

    .load-more-bar {
      text-align: center;
      padding-top: 10px;
    }
  }

  .empty-state {
    text-align: center;
    padding: 40px 0;
    color: #909399;

    i {
      font-size: 36px;
      margin-bottom: 8px;
      color: #dcdfe6;
    }
    p {
      font-size: 13px;
      margin: 0;
    }
  }
}

.full-width-input {
  width: 100% !important;
}

/* 会员选项排版美化 */
.modern-radio-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.plan-radio-item {
  width: 100% !important;
  margin: 0 !important;
  height: auto !important;
  padding: 10px 14px !important;
  border-radius: 8px !important;
}

::v-deep .plan-radio-item .el-radio__label {
  width: 100%;
  padding-left: 6px;
}

.plan-radio-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 90%;
}

.plan-name {
  font-size: 13px;
  color: #303133;
}

.plan-price {
  font-size: 14px;
  font-weight: bold;
  color: #fb7299;
}
</style>

<style lang="scss">
.mobile-dialog {
  border-radius: 12px !important;
  max-width: 340px;
}
</style>
